import { createHandbookResponseErrors } from '@/utils/error/responseErrors'
import { createNewHandbookApi } from '@/api/handbookApi'

export const GOST_URL = 'warehouse/gost-standards'

const errors = createHandbookResponseErrors('ГОСТ', 'ГОСТов')

export const GOSTApi = createNewHandbookApi(GOST_URL, errors)
